import Track from "util/Track";
import {handleScrollingSection} from "util/scrolling-section";
import TestimonialModal from "modals/TestimonialModal";
import TestimonialImageModal from "modals/TestimonialImageModal";

export function handleTestimonials() {
    let track = new Track($('.js-testimonial-track-wrap'), {
        classes: {
            block: "testimonial-slider",
        },
    });

    if ($(window).outerWidth() >= 1200) {
        track.disable();
    }

    $(window).on("resize", function () {
        if ($(window).outerWidth() >= 1200) {
            track.disable();
        } else {
            track.enable();
        }
    });

    handleScrollingSection($(".js-testimonial-track-wrap"));

    $('body').on('click', '.js-view-testimonial', function () {
        const $testimonial = $(this).closest('.js-testimonial');

        let modal = new TestimonialModal($testimonial.clone());
        modal.show();

        return false;
    }).on('click', '.js-view-testimonial-image', function () {
        let url = $(this).attr('href');

        let modal = new TestimonialImageModal(url);
        modal.show();

        return false;
    }).on('click', '.js-modal-close', function () {
        $(this).parents('.modal').remove();
        $('body').removeClass('modal-active');
        return false;
    })
}
